export default {
  unavailable: {
    title: 'Facturile pentru clienți nu sunt disponibile',
    description:
      'Clienții care comandă la restaurantele dvs. nu pot solicita o factură, deci nu este nimic de configurat aici. Chitanțele de comandă și facturile emise de furnizorul dvs. nu sunt afectate.',
  },
};
